export const ENDPOINT_NEWS_FIND_ALL = '/api/news/list';
export const ENDPOINT_NEWS_FIND_ONE = '/api/news/get-one';
export const ENDPOINT_NEWS_CREATE_ONE = '/api/news/create';
export const ENDPOINT_NEWS_DELETE_ONE = '/api/news/delete';
export const ENDPOINT_NEWS_UPDATE_ONE = '/api/news/update';
